module.exports = __webpack_public_path__ + "img/dsh.53bd3eba.svg";